import {
  Component,
  HostListener,
  ElementRef,
  ViewChild,
  Renderer2,
  OnInit, Input, PLATFORM_ID, inject,
} from '@angular/core';
import $ from 'jquery';
import { Router, NavigationEnd, RouteReuseStrategy } from '@angular/router';
import { ApidataService } from '../apidata.service';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import swal from 'sweetalert2';
import { RouterModule } from '@angular/router';
import { HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { environment, GINConstants } from '../../environments/environments';
import { IconsFreeToolsComponent } from '../icons-free-tools/icons-free-tools.component';
import { TranslateService } from '@ngx-translate/core';
import { TranslateModule } from '@ngx-translate/core';
import { ActivatedRoute } from '@angular/router';
import { LanguageService } from '../services/language.service';
import {
  SUPPORTED_LANGUAGES,
  DEFAULT_LANGUAGE,
} from '../config/language.config';
import { NavigationStart } from '@angular/router';
import { filter, take } from 'rxjs/operators';

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    IconsFreeToolsComponent,
    TranslateModule,
  ],
  templateUrl: './header.component.html',
  styleUrl: './header.component.css',
  providers: [ApidataService],
})
export class HeaderComponent implements OnInit {
  private platformId = inject(PLATFORM_ID);
  public hidehomeoption: boolean = false;
  public checkLogin = false;
  profile_id;
  checktoken;
  firstName;
  lastName;
  premium_user: boolean = false;
  public homeText = '';
  public doc_id = '';
  public href: string = "";
  paymentstatus = '';
  premium_user_done: boolean = false;
  isLoading: boolean = true;
  languages = this.languageService.languages;
  selectedLanguage: any;
  supportedLanguages = SUPPORTED_LANGUAGES;

  private readonly LANGUAGE_KEY = 'selectedLanguage';

  email;
  constructor(private router: Router, private httpClient: ApidataService,
    private routeReuseStrategy: RouteReuseStrategy,
    private elementRef: ElementRef,
    private translate: TranslateService,
    private route: ActivatedRoute,
    private renderer: Renderer2,
    private languageService: LanguageService,) {

    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      });
    this.translate.setDefaultLang('en');
  }
  switchLanguage(language: string) {
    this.translate.use(language);
  }
  navigatetoopenfile() {
    this.router.navigate(['/openfile']);
    window.location.reload;
  }
  reloadPage() {
    window.location.reload();
  }
  navigateTosignin() {
    this.router.navigate(['/signin']);
  }
  public gcrouteto() {

    this.router.navigate(['/grammar-checker'])
  }
  public grouteto() {

    this.router.navigate([''])
  }
  public PProute() {

    this.router.navigate(['/privacy-policy']);
  }
  public TCroute() {

    this.router.navigate(['/terms-conditions'])
  }
  public CUroute() {

    this.router.navigate(['/contact-us'])
  }
  public AUroute() {

    this.router.navigate(['/about-us'])
  }
  public PCroute() {

    this.router.navigate(['/plagiarism-checker'])
  }
  public SUMCroute() {

    this.router.navigate(['/text-summarizer'])
  }
  public ARCroute() {

    this.router.navigate(['/article-rewriter'])
  }
  public PACroute() {

    this.router.navigate(['/paraphrasing-tool'])
  }
  public AICroute() {

    this.router.navigate(['/ai-content-detector'])
  }
  help() {
    this.router.navigate(['/help-center'])
  }
  pricing() {
    this.router.navigate(['/pricing'])
  }
  fullName;

  public fetchProfileData() {
    this.profile_id = localStorage.getItem('profile_id');
    if (this.profile_id && this.profile_id != 1) {
      this.httpClient.getUserProfileContents(this.profile_id).subscribe((data) =>
        this.LoadProfileData(data)
      );
    } else {
      this.isLoading = false;
    }
  }
  public LoadProfileData(data: Response) {
    let receivedData = data;
    this.firstName = receivedData['contents'][0][1];

    this.lastName = receivedData['contents'][0][2];

    this.premium_user = ['premium_user', 'free_trial'].includes(receivedData['contents'][0][5]);

    this.isLoading = false;
  }
  currentLang: string;

  defaultLang = DEFAULT_LANGUAGE;

  defaultLanguage = {
    name: 'English ',
    icon: '/assets/images/plagiarism checker1/language.svg',
    code: 'en',
  };

  ngOnInit() {

    const langCode = this.languageService.getLanguageFromUrl(this.router.url);
    const lang = this.languageService.languages.find(
      (l) => l.code === langCode
    );
    if (lang) {
      this.languageService.setLanguage(lang);
    }

    this.languageService.selectedLanguage$.subscribe((language) => {
      this.selectedLanguage = language;
      this.translate.use(language.code);
    });

    const storedLanguage = localStorage.getItem('selectedLanguage');

    if (storedLanguage) {
      this.selectedLanguage = JSON.parse(storedLanguage);
      this.translate.use(this.selectedLanguage.code);
    } else {
      // this.translate.use('en');
    }

    this.checktoken = localStorage.getItem('authentication_token');

    this.checkLogin = this.httpClient.isLoggedIn();

    if (this.checkLogin || this.checktoken) {
      this.profile_id = localStorage.getItem('profile_id');

    } else {
      this.profile_id = '1';
    }
    if (!this.httpClient.isAuthenticatedVerificationSimple()) {

      var token = localStorage.getItem('token');
      if (token) {
        localStorage.clear();
        this.profile_id = '1';
        this.router.navigate(["/signin"]);
        swal({
          background: "#FFFFFF",
          html: `
              <div style="position: fixed; top: 50%; left: 50%; transform: translate(-50%, -50%); width: 468px; height: 360px;
                background-color: white; z-index: 9999999999999999; border-radius: 4px; border: 1px solid #E3E3F0;">
                <div class="text-center" style="margin-top: 9%;">
                  <img src="/assets/images/paraphrasing tool/alert.svg" alt="Alert" />
                  <div style="width: 323px; height: 64px; margin-left: 77px;">
                    <p class="error mt-4" style="font-size: 20px; font-weight: 500; line-height: 33.89px;">
                      Your token has been expired, please login again.
                    </p>
                  </div>
                  <button id="swal-ok-button" style="color: white; background-color: black; border: 1px solid black;
                    border-radius: 8px; width: 150px; height: 50px; font-size: 16px; font-weight: 600;"
                    class="mt-4 butn-alert">Ok</button>
                </div>
              </div>
            `,
          showConfirmButton: false,
          width: "323px",
          timer: 4000
        });
      }

    }
    this.profilename();
    this.fetchProfileData()

  }


  getSelectedLanguage() {
    // return this.languageService.getLanguage();
  }
  ///// end language conveter
  public ngAfterViewInit(): void {
  }
  //// get user profile info
  profilename() {
    if (this.checkLogin || this.checktoken) {
      this.profile_id = localStorage.getItem('profile_id');
      this.httpClient.getUserProfileContents(this.profile_id).subscribe({
        next: (response: HttpResponse<any>) => {

          if (response.status === 200) {
            const receivedData = response.body;

            this.email = receivedData["contents"][0][0];
            this.firstName = receivedData['contents'][0][1];

            this.lastName = receivedData['contents'][0][2];

            this.paymentstatus = receivedData['contents'][0][5];


            this.premium_user_done = this.paymentstatus === 'premium_user' || this.paymentstatus === 'free_trial';
            localStorage.setItem('premium_user_done', JSON.stringify(this.premium_user_done));
          }
        },
        error: (error: HttpErrorResponse) => {

          if (error.status === 401) {

            localStorage.clear();
            this.router.navigate(['/signin'])

          } else {


          }
        }
      });
    }
  }
  ////////////////// logout and clear storage
  public logout() {
    this.httpClient.logout();
    localStorage.clear();
    this.router.navigate(['/']);
    setTimeout(() => {
      this.onRefresh();
    }, 1000);
  }
  onRefresh() {
    this.router.routeReuseStrategy.shouldReuseRoute = function () {
      return false
    }
    const currentUrl = this.router.url + '?'
    return this.router.navigateByUrl(currentUrl).then(() => {
      this.router.navigated = false
      this.router.navigate([this.router.url])
    })
  }
  public routetoaccount() {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });

    window.open('/accountsettings', "_blank");
  }
  public gotoeditor(type) {
    let data2 = JSON.stringify({
      homeText: this.homeText,
      profile_id: this.profile_id
    });
    let url = environment.API_URL + '/api/getNewDocIDForGuestByContents';
    this.httpClient.postResources(data2, url).subscribe(data => {
      let receivedData = data;

      this.doc_id = receivedData['new_doc_id'];
      // this.router.navigate(['/document/', this.doc_id]);
      this.router.navigate(['/grammar-check'], { queryParams: { doc: this.doc_id } });
      var editortxt = '';
      editortxt = this.homeText;
      localStorage.setItem('editorValueAI', editortxt);
      const url = this.router.serializeUrl(this.router.createUrlTree(['']));
    });
  }
  public routetoaccountsetting() {
    window.open('/accountsettings', "_blank");
  }
  isDropdownVisible = false;

  toggleDropdown() {
    this.isDropdownVisible = !this.isDropdownVisible;
  }

  // selectLanguage(name: string, icon: string) {
  //   this.selectedLanguage.name = name;
  //   this.selectedLanguage.icon = icon;
  //   this.isDropdownVisible = false;
  // }

  @
    HostListener('document:click', ['$event'])
  closeDropdownOnOutsideClick(event: Event) {
    const clickedElement = event.target as HTMLElement;
    if (!this.elementRef.nativeElement.contains(clickedElement) && !clickedElement.classList.contains('btn')) {
      this.isDropdownVisible = false;
    }
  }
  activeDropdown: string = '';
  toggleDropdowns(dropdown: string) {
    if (this.activeDropdown === dropdown) {
      this.activeDropdown = '';
    } else {
      this.activeDropdown = dropdown;
    }
  }
  close() {
    document.getElementById("navbarSupportedContent").style.display = "none";
    document.getElementById("navopen").style.display = "inline-block";
  }
  @HostListener('document:click', ['$event'])
  clickOutside(event: Event) {
    const dropdownElement = document.getElementById('navbarDropdown');
    const isClickedInside = dropdownElement?.contains(event.target as Node);
    if (!isClickedInside) {
      this.activeDropdown = null;
    }
  }
  @ViewChild('navbarContent') navbarContent!: ElementRef;
  toggleNav() {

    const isCollapsed = this.navbarContent.nativeElement.classList.contains('show');
    if (isCollapsed) {
      this.closeNav();
    } else {
      this.openNav();
    }
  }

  openNav() {
    this.renderer.addClass(this.navbarContent.nativeElement, 'show');
  }

  closeNav() {
    this.renderer.removeClass(this.navbarContent.nativeElement, 'show');
  }
  selectLanguage(language) {
    this.languageService.setLanguage(language);
    localStorage.setItem(
      'selectedLanguage',
      JSON.stringify(this.selectedLanguage)
    );
    this.translate.use(language.code);

    // this.profile_id !== '1' &&
    //   this.httpClient
    //   .updateUserLanguage(this.profile_id, language.code === "en" ? "en-us" : language.code)

    //     .subscribe();
    if (
      isPlatformBrowser(this.platformId) &&
      this.profile_id !== '1'
    ) {
      console.log('Running in browser and profile_id is not 1. Proceeding with language update.');

      this.httpClient
        .updateUserLanguage(this.profile_id, language.code === 'en' ? 'en-us' : language.code)
        .subscribe(
          res => {
            console.log('Language update response:', res);
          },
          err => {
            console.error('Error updating language:', err);
          }
        );
    }

    this.isMenuOpen = null;

    const currentUrl = this.router.url;
    const segments = currentUrl.split('/');

    if (this.languageService.languages.some((l) => l.code === segments[1])) {
      segments.splice(1, 1);
    }

    const newUrl =
      language.code === 'en'
        ? '/' + segments.slice(1).join('/')
        : '/' + language.code + '/' + segments.slice(1).join('/');

    this.router.navigateByUrl(newUrl);



    this.router.events.subscribe((event) => {
      if (event instanceof NavigationStart) {
        let url = event.url;

        if (url !== '/' && url.endsWith('/')) {
          url = url.slice(0, -1);
          this.router.navigateByUrl(url);
          return;
        }

        if (url === '/' || url === '') {
          const selectedLang = this.selectedLanguage?.code || 'en';
          if (selectedLang !== 'en') {
            this.router.navigateByUrl(`/${selectedLang}`);
          }
        }

      }
    });



  }
  isMenuOpen = false;

  toggleMenu() {
    this.isMenuOpen = !this.isMenuOpen;
    this.isDropdownVisible = !this.isDropdownVisible;
  }
  allowedRoutes: string[] = ['/', '/es', '/pt'];
  shouldShowLanguageDropdown(): boolean {

    const currentUrl = this.router.url;
    return this.allowedRoutes.includes(currentUrl);
  }

}

